<template>
  <div>
    <div class="lastBottom end" id="objectiveBottomSecondary">
      <div class="cols">
        <div class="centered">
          <h4>
            Pour vendre vos articles en magasin,
            <br />téléchargez l'application
          </h4>
          <div class="osReverse" v-bind:class="{ reverse: isAndroid }">
            <a
              v-bind:href="global.apple_link"
              v-bind:title="global.download_apple"
              target="_blank"
              rel="noopener"
            >
              <img
                class="download_button"
                src="@/assets/images/SVG/ios_download.svg"
                height="38"
                v-bind:alt="global.download_google"
              />
            </a>
            <a
              v-bind:href="global.google_link"
              v-bind:title="global.download_google"
              target="_blank"
              rel="noopener"
            >
              <img
                class="download_button"
                src="@/assets/images/SVG/google_play_FR.svg"
                height="38"
                v-bind:alt="global.download_google"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="lastBottom" id="objectiveBottom">
      <div class="cols">
        <div class="centered">
          <h4>
            Pour vendre vos articles en magasin, téléchargez l’application
          </h4>
          <div class="osReverse" v-bind:class="{ reverse: isAndroid }">
            <a
              v-bind:href="global.apple_link"
              target="_blank"
              v-bind:title="global.download_apple"
              rel="noopener"
            >
              <img
                class="download_button"
                src="@/assets/images/SVG/ios_download.svg"
                height="38"
                v-bind:alt="global.download_apple"
              />
            </a>
            <a
              v-bind:href="global.google_link"
              v-bind:title="global.download_google"
              target="_blank"
              rel="noopener"
            >
              <img
                class="download_button"
                src="@/assets/images/SVG/google_play_FR.svg"
                height="38"
                v-bind:alt="global.download_google"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="centered">
        <img
          src="@/assets/images/SVG/idkids_brands.svg"
          width="320"
          style="min-width:280px; max-width:550px; width:100%;"
          alt="idkids we act for kids marques idtroc"
        />
      </div>
      <div class="cols cont">
        <div class="col">
          <h4>Liens pratiques</h4>
          <ul>
            <li>
              <a
                href="https://www.okaidi.fr/programme-fidelite-2"
                target="_blank"
                rel="noopener"
              >
                Programme de
                <b>fidélité Okaïdi-obaïbi</b>
              </a>
            </li>
            <li>
              <a
                href="https://www.oxybul.com/programme-fidelite"
                target="_blank"
                rel="noopener"
              >
                Programme de
                <strong>fidélité Oxybul</strong>
              </a>
            </li>
            <li>
              <router-link
                to="/FAQ"
                target="_self"
                name="réponses aux questions à propos de idtroc"
                rel="tag"
              >
                Foire aux questions IDTROC
              </router-link>
            </li>
            <li>
              <router-link
                to="/CGU"
                target="_self"
                name="conditions générales d'utilisation de l'application idtroc"
                rel="tag"
              >
                Conditions générales d'utilisation
              </router-link>
            </li>
            <li>
              <router-link
                to="/mentions-legales"
                target="_self"
                name="mentions légales de l'application idtroc"
                rel="tag"
              >
                Mentions Légales
              </router-link>
            </li>
            <li>
              <router-link
                to="/politique-confidentialite"
                target="_self"
                name="politique de confidentialité de l'application idtroc"
                rel="tag"
              >
                Politique de Confidentialité
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col">
          <h4>Communauté & Marques</h4>
          <ul>
            <li>
              <a
                href="https://www.idkids.fr/idtroc-vetements-et-jouets-d-occasion-okaidi-obaibi-oxybul"
                title="IDTROC sur idkids"
                target="_blank"
                rel="noopener"
              >
                ÏDKIDS
              </a>
            </li>
            <li>
              <a
                href="https://www.okaidi.fr/idtroc-4"
                title="idtroc sur okaidi obaibi"
                target="_blank"
                rel="noopener"
              >
                Okaïdi - Obaïbi
              </a>
            </li>
            <li>
              <a
                href="https://www.oxybul.com/id-troc"
                title="idtroc sur oxybul"
                target="_blank"
                rel="noopener"
              >
                Oxybul
              </a>
            </li>
            <li>
              <a
                href="https://www.catimini.com/fr-fr/website/465-idtroc"
                title="catimini sur oxybul"
                target="_blank"
                rel="noopener"
              >
                Catimini
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "footerIdtroc",
  data() {
    return {};
  },
  computed: {
    global() {
      return this.$store.getters.global;
    },
    isAndroid() {
      return this.$store.getters.isAndroid;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue